import { Radio } from 'antd';
import RadioCard from './RadioCard';
import RadioGroup from './RadioGroup'; // copy-pasted from antd, to solve TS4023 error

// @ts-expect-error
var CustomRadio = Radio;
CustomRadio.Group = RadioGroup;
CustomRadio.Card = RadioCard;
export default CustomRadio;